<template>
  <!-- 广告首页 -->
  <div class="video">
    <div class="video_box">
      <el-card>
        <el-form :inline="true" id="myform" label-width="120px" size="small">
          <el-row>
            <el-col :span="8">
              <el-form-item label="标题">
                <el-input placeholder="请输入标题" v-model="searchData.title" clearable></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="作者">
                <el-select clearable placeholder="请选择" v-model="searchData.authorId">
                  <el-option
                    v-for="item in author"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>-->

            <el-col :span="8">
              <el-form-item label="是否轮播">
                <el-select clearable placeholder="请选择" v-model="searchData.isRotation">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in isOrnot"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="猜你喜欢">
                <el-select clearable placeholder="请选择" v-model="searchData.isLike">
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in isOrnot"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="状态">
                <el-select
                  clearable
                  placeholder="请选择"
                  size="small"
                  v-model="searchData.examineStatus"
                >
                  <el-option
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    v-for="item in newsStatus"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div>
            <el-form-item>
              <el-button
                @click="searchList"
                style="margin-left: 120px"
                type="primary"
                v-if="menuPerm('video:query')"
              >查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button @click="addList" type="primary" v-if="menuPerm('video:add')">添加</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="empty">清空</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-card>
      <el-card>
        <el-table
          :data="list"
          border
          ref="multipleTable"
          style="width: 100%; flex: auto"
          tooltip-effect="light"
        >
          <el-table-column label="标题" prop="title" width="200px" align="center">
             <template slot-scope="{row}">
                <a-tooltip>
              <template slot="title">{{row.title}}</template>
              <span class="news_title">{{row.title}}</span>
            </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="视频" prop="ossUrl" width="200px" align="center">
            <template slot-scope="{row}">
              <div class="video_url">
                <video
                  :src="row.ossUrl"
                  controls="controls"
                  style="width:150px;height:150px"
                  :poster="row.frontCoverUrl"
                ></video>
              </div>
            </template>
          </el-table-column>
          <!-- <el-table-column label="封面图" prop="frontCoverUrl" width="200px" align="center">
            <template slot-scope="{row}">
              <div class="video_img">
                <img :src="row.frontCoverUrl" style="width:150px;height:150px" />
              </div>
            </template>
          </el-table-column>-->
          <!-- <el-table-column label="评论数" prop="commentCount" width="80px" align="center"></el-table-column>
          <el-table-column label="点赞数" prop="favorCount" width="80px" align="center"></el-table-column>-->
          <el-table-column label="发布时间" prop="publishTimestamp" align="center" width="180px"></el-table-column>
          <el-table-column align="center" label="是否轮播" prop="isRotation">
            <template slot-scope="{row}">
              <div v-if="row.isRotation == 1">是</div>
              <div v-if="row.isRotation == 0">否</div>
            </template>
          </el-table-column>
          <el-table-column align="center" label="猜你喜欢" prop="isLike">
            <template slot-scope="{row}">
              <div v-if="row.isLike == 1">是</div>
              <div v-if="row.isLike == 0">否</div>
            </template>
          </el-table-column>
          <el-table-column label="摘要" prop="remark" align="center" width="200px">
                   <template slot-scope="{row}">
                <a-tooltip>
              <template slot="title">{{row.remark}}</template>
              <span class="news_title">{{row.remark}}</span>
            </a-tooltip>
            </template>
          </el-table-column>
          <el-table-column align="center" label="审核状态" prop="examineStatus" width="180px">
            <template slot-scope="{row}">
              <div v-if="menuPerm('video:submit_review')">
                <span v-if="row.examineStatus == 2 ">未提交审核</span>
                <span v-if="row.examineStatus == 3 ">审核中</span>
                <span v-if="row.examineStatus == 4 ">审核未通过</span>
                <span v-if="row.examineStatus == 1 ">审核通过</span>
              </div>

              <el-select
                placeholder="请选择"
                v-model="row.examineStatus"
                v-if="menuPerm('video:review')"
                @change="examChange($event,row)"
              >
                <el-option
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                  v-for="item in revernewsStatus"
                ></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            class-name="small-padding fixed-width"
            label="操作"
            width="200px"
            fixed="right"
          >
            <template slot-scope="{row}">
              <el-button
                type="primary"
                @click="removeList(row.id)"
                :disabled="(row.examineStatus == 1 || row.examineStatus == 3) && allOpen  ? true :false"
                v-if="menuPerm('video:delete')"
              >删除</el-button>
              <el-button
                type="primary"
                @click="changeMessage(row)"
                v-if="menuPerm('video:query')"
              >详情</el-button>
               <el-button
                type="primary"
                @click="push(row)"
                v-if="menuPerm('app:push')"
              >推送</el-button>
              <el-button
                type="primary"
                @click="changeExam(row.id)"
                v-if="menuPerm('video:submit_review')"
                 :disabled="(row.examineStatus == 1 || row.examineStatus == 3) && allOpen  ? true :false"
              >提交审核</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-row style="width:auto;marginRight:50px;marginTop:20px;">
          <el-pagination
            :current-page="currentPage"
            :page-size="pagesize"
            :page-sizes="[5,10,15]"
            :total="totalCount"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          ></el-pagination>
        </el-row>
      </el-card>
        <!-- 详情页面 -->
      <a-drawer
        title="视频详情"
        :width="900"
        :visible="visible"
        :body-style="{ paddingBottom: '80px' }"
        @close="onClose"
      >
        <Detail :Detaildata="detailData" />
      </a-drawer>
    </div>
    <!-- 删除弹出框 -->
    <a-modal :visible="delOpen" ok-text="确认" cancel-text="取消" @ok="handleOk" @cancel="handleCancel">
      <p>确定要删除吗？</p>
    </a-modal>
  </div>
</template>
<script>
import Detail from './videoEdit'
export default {
  data() {
    return {
       detailData:'',
      visible:false,

      allOpen: true, //没有限制
      delOpen: false, //删除--弹框
      delId: "", //删除id

      multipleSelection: [], //分页
      pagesize: 10,
      currentPage: 1, //初始页
      totalCount: 0, //分页数量展示
      list: [], //列表
      //查询的数据：
      searchData: {
        authorId: "", //作者id
        title: "", //标题
        isRotation: "", //是否轮播
        examineStatus: "", //是否过审
        isLike: "" //猜你喜欢
      },
      //是否轮播:--下拉框
      isOrnot: [
        {
          value: "1",
          label: "是"
        },
        {
          value: "0",
          label: "不是"
        }
      ],
      author: "", //作者
      //状态--下拉框：
      revernewsStatus: [
        {
          value: "1",
          label: "审核通过"
        },
        {
          value: "3",
          label: "审核中"
        },
        {
          value: "4",
          label: "审核未通过"
        }
      ],

      //状态--下拉框：--发布者
      newsStatus: [
        {
          value: "2",
          label: "未提交审核"
        },
        {
          value: "3",
          label: "审核中"
        },
        {
          value: "4",
          label: "审核未通过"
        },
        {
          value: "1",
          label: "审核通过"
        }
      ]
    };
  },
          components: {
    Detail
  },
  methods: {
      onClose() {
      this.visible = false;
    },
    //修改音频专辑的审核状态---审核者（r）
    examChange(val, row) {
      this.getAxios("/video/review", {
        id: row.id,
        examineStatus: val
      }).then(res => {
        if (res.success == true) {
          this.$message.success("修改审核状态成功");
          this.getList(); //列表
        } else if (res.success == false) {
          this.$message.error("修改审核状态失败");
        } else if (
          !res.success && res.statusCode == "401"
        ) {
           this.$message.error(res.message);
        }
      });
    },
    // p-->提交审核--发布者
    changeExam(id) {
      this.getAxios("/video/submit/review", {
        id: id //专辑的id
      }).then(res => {
        if (res.success == true) {
          this.$message.success("提交审核成功！");

          this.getList(); //列表
        } else if (res.success == false) {
          this.$message.error("提交审核失败");
        } else if (
          !res.success && res.statusCode == "401"
        ) {
          this.$message.error(res.message);
        }
      });
    },

    //作者：
    getAuthor() {
      this.getAxios("/manager/list/userInfo", {
        managerId: localStorage.getItem("userId")
      }).then(res => {
        if (res.success == true) {
          this.author = res.content;
        } else if (!res.success && res.statusCode == "401") {
           this.$message.error(res.message);
        }
      });
    },
    //头部样式
    getRowClass({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f5f7fa;color:#000;width:100%;text-aligin:center;text-align: center;";
      } else {
        return "";
      }
    },
    //分页
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //分页：
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.getList();
    },
    //分页
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 清空数据
    empty() {
      this.searchData.title = "";
      this.searchData.authorId = "";
      this.searchData.isRotation = "";
      this.searchData.examineStatus = "";
      this.searchData.isLike = "";
    },
    //删除-弹框-取消
    handleCancel() {
      this.delOpen = false;
    },
    //确定删除
    handleOk() {
      this.getAxios("/video/delete", {
        id: this.delId
      }).then(res => {
        if (res.success == true) {
          this.$message.success("删除成功！");
          this.delOpen = false;
          this.getList();
        } else if (res.success == false) {
          this.$message.error("删除失败");
        } else if (
          !res.success && res.statusCode == "401"
        ) {
          this.$message.error(res.message);
        }
      });
    },
    // 删除
    removeList(id) {
      this.delId = id; //删除id
      this.delOpen = true;
    },
    // 修改
    changeMessage(row) {
      // this.$router.push({ path: "/videoEdit", query: { data: row } });
      this.detailData = row; //数据
      this.visible = true;
    },
    // app推送
    push(row) {
      this.getAxios("/app/push", {
        type: 5,
        id: row.id,
      }).then((res) => {
        if (res.success == true) {
          this.$message.success(res.message);
        } else if (res.success == false) {
          this.$message.error(res.message);
        } else if (res.success == false && res.statusCode == "401") {
          this.$message.error(res.message);
          this.$router.push("/");
        }
      });
    },
    //查询数据：
    getList() {
      this.postAxios("/video/list", {
        pageNum: this.currentPage,
        pageSize: 10,
        isLike: this.searchData.isLike, //猜你喜欢，1 是，0 否
        examineStatus: this.searchData.examineStatus, //是够过审，1 是，0 否
        isRotation: this.searchData.isRotation, //是否轮播，1 是 0 否
        title: this.searchData.title, //标题
        authorId: this.searchData.authorId //作者id，下拉框选择
      }).then(res => {

        if(res.success == true){
                  this.list = res.content;
        this.totalCount = res.totalCount;
        // 时间戳转时间：
        this.list.map((i, index) => {
          if (i.publishTimestamp != null && i.publishTimestamp != 0) {
            var timeTrans = new Date(parseInt(i.publishTimestamp) * 1000);
            let reviewTimestampsd = timeTrans.toLocaleString("chinese", {
              hour12: false
            });
            this.$set(this.list[index], `publishTimestamp`, reviewTimestampsd);
          } else {
            this.$set(this.list[index], `publishTimestamp`, "");
          }
        });
        }
        else if (
          !res.success && res.statusCode == "401"
        ) {
          this.$message.error(res.message);
          this.$router.push('/')
        }else if(res.success==false){
          this.$message.error(res.message);
        }


      });
    },
    // 点击查询
    searchList() {
      this.currentPage = 1;
      this.getList();
    },
    // 点击添加
    addList() {
      this.$router.push("/videoAdd");
    }
  },
  mounted() {
    this.getList();
  },
  created() {
    if (this.menuPerm("video:edit_super") == true) {
      this.allOpen = false;
    }
  }
};
</script>
<style scoped lang="less">
.video {
  width: 100%;
  height: 100%;
  .video_box {
    width: 95%;
    height: auto;
    margin: 20px auto;
    .el-card {
      margin-top: 15px;
      .news_title {
  display: block;
  width: 170px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
      .video_url {
        width: 200px;
        height: 150px;
        margin-left: -10px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;
        video {
          width: 100%;
          height: auto;
        }
      }
      .video_img {
        width: 200px;
        height: 150px;
        margin-left: -10px;
        display: table-cell;
        vertical-align: middle;
        text-align: center;

        img {
          width: 100%;
          height: auto;
        }
      }

      /deep/ .el-button--primary {
        color: #fff;
        background-color: #409eff;
        border-color: #409eff;
        width: 100px;

        margin-top: 10px;
        margin-left: 10px;
      }
    }
  }
}
</style>
